import { deserialize } from 'cerialize'

export class SettingModel {
	@deserialize public key: string
	@deserialize public data: { [key: string]: any }
}
